<template>
  <div class="wechat-window" :class="{ dark: isDark }">
    <!-- 左侧会话列表 -->
    <div class="chat-list-panel" ref="leftPanel">
      <div class="search-bar">
        <input v-model="searchKeyword" placeholder="搜索" />
      </div>

      <div class="chat-list">
        <div
          v-for="(chat, index) in filteredChats"
          :key="index"
          class="chat-item"
          :class="{ active: index === currentChatIndex }"
          @click="openChat(index)"
        >
          <div class="chat-item-avatar"></div>
          <div class="chat-item-content">
            <div class="chat-item-name">{{ chat.name }}</div>
            <div class="chat-item-last">
              {{ chat.messages[chat.messages.length - 1].text }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 拖动条 -->
    <div class="resizer" @mousedown="startDrag"></div>

    <!-- 右侧聊天区域 -->
    <div class="chat-panel">
      <div class="chat-header">
        <div>{{ currentChatName }}</div>
        <button @click="toggleDarkMode">深色模式</button>
      </div>

      <div class="chat-history" ref="chatHistory">
        <template v-if="currentChat">
          <template v-for="(msg, i) in currentChat.messages" :key="i">
            <!-- 时间戳 -->
            <div
              v-if="shouldShowTime(i)"
              class="msg-time"
            >
              {{ formatTime(msg.time) }}
            </div>

            <!-- 消息 -->
            <div class="msg-row" :class="{ me: msg.me }">
              <div class="msg-bubble">{{ msg.text }}</div>
            </div>
          </template>
        </template>
      </div>

      <!-- 输入区 -->
      <div class="chat-input-panel">
        <div class="emoji-btn" @click="toggleEmojiPanel">😀</div>
        <div class="emoji-panel" v-show="showEmojiPanel">
          <span v-for="(e, i) in emojis" :key="i"  @click="insertEmoji(e)" >
            {{ e }}
          </span>
        </div>
        <textarea
          v-model="inputText"
          placeholder="输入消息..."
          @keydown.enter.exact.prevent="handleEnter"
          @keydown.shift.enter.stop
        ></textarea>

        <button class="send-btn" @click="sendMessage">发送</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeChat",

  data() {
    return {
      chats: [
        {
          name: "文件传输助手",
          messages: [
            { me: false, text: "你好，这是一个模拟微信界面。", time: Date.now() - 600000 },
            { me: true, text: "看起来不错！", time: Date.now() - 480000 }
          ]
        },
        {
          name: "张三",
          messages: [{ me: false, text: "明天记得开会", time: Date.now() - 1800000 }]
        },
        {
          name: "项目群",
          messages: [{ me: false, text: "最新版本已经发布", time: Date.now() - 3600000 }]
        }
      ],

      currentChatIndex: null,
      inputText: "",
      searchKeyword: "",
      isDark: false,
      showEmojiPanel: true,

     // emojis: "😁😀😂🤣😅😊😍😘😎😢😭😡👍👎🙏👏🔥✨❤️💔".split(''),
      emojis: [],
      dragging: false
    };
  },

  computed: {
    filteredChats() {
      const key = this.searchKeyword.toLowerCase();
      if (!key) return this.chats;

      return this.chats.filter(c => {
        const last = c.messages[c.messages.length - 1].text.toLowerCase();
        return c.name.toLowerCase().includes(key) || last.includes(key);
      });
    },

    currentChat() {
      return this.currentChatIndex !== null
        ? this.chats[this.currentChatIndex]
        : null;
    },

    currentChatName() {
      return this.currentChat ? this.currentChat.name : "请选择一个会话";
    }
  },
  created() {
    this.emojis.push('😀');
    this.emojis.push('😀');
    this.emojis.push('😂');
    this.emojis.push('🤣');
    this.emojis.push('😅');
    this.emojis.push('😍');
    this.emojis.push('😘');
    this.emojis.push('😎');
  },
  methods: {
    openChat(index) {
      this.currentChatIndex = index;
      this.$nextTick(() => this.scrollToBottom());
    },

    sendMessage() {
      if (this.currentChatIndex === null) return;
      const text = this.inputText.trim();
      if (!text) return;

      this.chats[this.currentChatIndex].messages.push({
        me: true,
        text,
        time: Date.now()
      });

      this.inputText = "";
      this.$nextTick(() => this.scrollToBottom());
    },

    handleEnter(e) {
      if (!e.shiftKey) this.sendMessage();
    },

    toggleDarkMode() {
      this.isDark = !this.isDark;
    },

    toggleEmojiPanel() {
      this.showEmojiPanel = !this.showEmojiPanel;
    },

    insertEmoji(e) {
      this.inputText += e;
    },

    shouldShowTime(i) {
      if (i === 0) return true;
      const prev = this.currentChat.messages[i - 1].time;
      const now = this.currentChat.messages[i].time;
      return now - prev > 5 * 60 * 1000;
    },

    formatTime(t) {
      return new Date(t).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    scrollToBottom() {
      const el = this.$refs.chatHistory;
      if (el) el.scrollTop = el.scrollHeight;
    },

    /* 拖动侧边栏 */
    startDrag() {
      this.dragging = true;
    }
  },

  mounted() {
    document.addEventListener("mouseup", () => (this.dragging = false));

    document.addEventListener("mousemove", e => {
      if (!this.dragging) return;
      const w = e.clientX;
      if (w > 200 && w < 500) {
        this.$refs.leftPanel.style.width = w + "px";
      }
    });
  }
};
</script>

<style>
/* 这里直接使用你之前的完整 CSS */
/* 我已完整保留，不需要任何修改 */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.wechat-window {
  width: 100%;
  height: 100vh;
  display: flex;
  background: var(--bg);
  color: var(--text);
  transition: background 0.3s, color 0.3s;
}

/* 亮色模式 */
:root {
  --bg: #e5e5e5;
  --panel: #f5f5f5;
  --border: #dcdcdc;
  --text: #333;
  --text-light: #777;
  --bubble-me: #95ec69;
  --bubble-other: #fff;
}

/* 深色模式 */
.dark {
  --bg: #1e1e1e;
  --panel: #2a2a2a;
  --border: #444;
  --text: #eee;
  --text-light: #aaa;
  --bubble-me: #3a7f2f;
  --bubble-other: #3a3a3a;
}

/* 左侧会话列表 */
.chat-list-panel {
  width: 300px;
  min-width: 200px;
  max-width: 500px;
  background: var(--panel);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  transition: width 0.1s;
}

.search-bar {
  padding: 10px;
  border-bottom: 1px solid var(--border);
}

.search-bar input {
  width: 100%;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--bg);
  color: var(--text);
  outline: none;
}

.chat-list {
  flex: 1;
  overflow-y: auto;
}

.chat-item {
  display: flex;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid var(--border);
  transition: background 0.2s;
}

.chat-item:hover {
  background: rgba(0,0,0,0.05);
}

.chat-item.active {
  background: rgba(0,0,0,0.1);
}

.chat-item-avatar {
  width: 40px;
  height: 40px;
  background: #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.chat-item-content {
  flex: 1;
}

.chat-item-name {
  font-size: 14px;
  font-weight: bold;
}

.chat-item-last {
  font-size: 12px;
  color: var(--text-light);
  margin-top: 4px;
}

/* 拖动条 */
.resizer {
  width: 5px;
  cursor: col-resize;
  background: transparent;
}

/* 右侧聊天区域 */
.chat-panel {
  flex: 1;
  background: var(--panel);
  display: flex;
  flex-direction: column;
  position: relative;
}

.chat-header {
  height: 50px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.chat-history {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
}

.msg-time {
  text-align: center;
  font-size: 12px;
  color: var(--text-light);
  margin: 10px 0;
}

.msg-row {
  display: flex;
  margin-bottom: 10px;
}

.msg-row.me {
  justify-content: flex-end;
}

.msg-bubble {
  max-width: 60%;
  padding: 8px 12px;
  border-radius: 4px;
  background: var(--bubble-other);
  color: var(--text);
  word-break: break-word;
}

.msg-row.me .msg-bubble {
  background: var(--bubble-me);
}

/* 输入区域 + 表情 */
.chat-input-panel {
  border-top: 1px solid var(--border);
  padding: 10px;
  position: relative;
}

.emoji-btn {
  cursor: pointer;
  font-size: 20px;
  margin-bottom: 5px;
}

.emoji-panel {
  display: none;
  position: absolute;
  bottom: 120px;
  left: 20px;
  width: 220px;
  background: var(--panel);
  border: 1px solid var(--border);
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  flex-wrap: wrap;
  z-index: 10;
}

.emoji-panel span {
  font-size: 22px;
  padding: 5px;
  cursor: pointer;
}

.chat-input-panel textarea {
  width: 100%;
  height: 70px;
  resize: none;
  border: none;
  outline: none;
  background: var(--panel);
  color: var(--text);
  font-size: 14px;
}

.send-btn {
  margin-top: 8px;
  padding: 6px 14px;
  background: #1aad19;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* 响应式 */
@media (max-width: 700px) {
  .chat-list-panel {
    display: none;
  }
}
</style>
